import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ApiService } from '@services/api.service';

@Component({
  selector: 'ew-split-payment-summary',
  templateUrl: './split-payment-summary.component.html',
  styleUrl: './split-payment-summary.component.scss',
})
export class SplitPaymentSummaryComponent implements OnChanges {
  constructor(private API: ApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currency']) {
      if (this.currency) {
        this.API.get('v1/company-currency-accounts').subscribe(
          (response: any) => {
            this.currencyAccount = response.records.find(
              (currencyAccount: any) =>
                currencyAccount.currencyIso === this.currency,
            );
          },
        );
      }
    }
  }

  currencyAccount: any | null = null;

  @Input() currency: string | null = null;
  @Input() budget: number = 0;
  @Input() splits: any[] = [];

  get comission() {
    return (
      this.budget - this.splits?.reduce((sum, split) => sum + split.amount, 0)
    );
  }
}
